export enum actionTypes {
  RANGOS_EMPLEADOS_FETCH = 'RANGOS_EMPLEADOS_FETCH',
  RANGOS_EMPLEADOS_SUCCESS = 'RANGOS_EMPLEADOS_SUCCESS',
  RANGOS_EMPLEADOS_ERROR = 'RANGOS_EMPLEADOS_ERROR',
  RANGOS_EMPLEADOS_RESET = 'RANGOS_EMPLEADOS_RESET',
}

export enum RangosEmpleadosStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface RangoEmpleados {
  valor: number
  minimo: number
  maximo: number
  nombre: string
}

export interface RangosEmpleadosState {
  status: RangosEmpleadosStatus
  rangosEmpleados: Array<RangoEmpleados>
}

export interface RangosEmpleadosFetch {
  type: typeof actionTypes.RANGOS_EMPLEADOS_FETCH
  payload: null
}

export interface RangosEmpleadosSuccess {
  type: typeof actionTypes.RANGOS_EMPLEADOS_SUCCESS
  payload: Array<RangoEmpleados>
}

export interface RangosEmpleadosError {
  type: typeof actionTypes.RANGOS_EMPLEADOS_ERROR
  payload: null
}

export interface RangosEmpleadosReset {
  type: typeof actionTypes.RANGOS_EMPLEADOS_RESET
  payload: null
}

export type RangosEmpleadosActions =
  | RangosEmpleadosFetch
  | RangosEmpleadosSuccess
  | RangosEmpleadosError
  | RangosEmpleadosReset

export const initialState: RangosEmpleadosState = {
  status: RangosEmpleadosStatus.Idle,
  rangosEmpleados: [],
}
